module.exports = __webpack_public_path__ + "static/img/logo.5cacbdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo.png
// module id = KItN
// module chunks = 30